export enum ICON_BUTTON_CLICK_TARGET {
	CLOSE = 'close',
	SEND = 'send',
}
